var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinPlasticPinPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6434 16.3217C32.6434 25.3359 16.3217 47.4813 16.3217 47.4813C16.3217 47.4813 0 25.3359 0 16.3217C0 7.30747 7.30747 0 16.3217 0C25.3359 0 32.6434 7.30747 32.6434 16.3217Z",
    fill: "#168D8B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 12.8985C20.0001 13.8663 18.2762 14.5115 16.2649 14.5115C14.2537 14.5115 12.5298 13.8663 12.5298 12.8985C12.5298 11.9308 14.2537 11.2856 16.2649 11.2856C18.2762 11.2856 20.0001 11.9308 20.0001 12.8985Z",
    stroke: "#474747",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5298 12.8984L13.5917 19.7537C13.6457 20.1021 13.8835 20.3943 14.2137 20.5179V20.5179C15.5364 21.0129 16.9935 21.0129 18.3162 20.5179V20.5179C18.6464 20.3943 18.8842 20.1021 18.9382 19.7537L20.0001 12.8984",
    stroke: "#474747",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinPlasticPinPrimary);
export default __webpack_public_path__ + "static/media/trash-bin-plastic-pin-primary.bb117e519e755ca351996c2a53787519.svg";
export { ForwardRef as ReactComponent };